<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">用户管理·数据表格</h5>
        </a-col>
      </a-row>
    </template>
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
          <a-form-item label="用户名">
            <a-input v-model="dataForm.username" placeholder="用户名搜索" allowClear></a-input>
          </a-form-item>
          <a-form-model-item ref="department_pid" label="所属部门" prop="department_pid">
            <department-select ref="departmentSelect" v-model="dataForm.department_id" :style="{ width: '200px' }"
              allowClear></department-select>
          </a-form-model-item>
          <a-form-model-item ref="resign" label="在职状态" prop="resign">
            <a-select v-model="dataForm.resign" placeholder="请选择" allowClear style="width: 120px;">
              <a-select-option value="1">在职状态</a-select-option>
              <a-select-option value="2">离职状态</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增用户</a-button>
          </a-form-item>
        </a-form>

        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="user_id"
          :loading="dataListLoading" :scroll="{ x: 1400 }">
          <template slot="username" slot-scope="text, row">
            <div class="table-avatar-info">
              <!-- <a-avatar shape="square" src="images/company.png" /> -->
              <div class="avatar-info">
                <h6 class="m-2">登录名：{{ row.username }}</h6>
                <p class="m-0 font-regular text-muted">
                  用户ID：{{ row.user_id }}
                </p>
              </div>
            </div>
          </template>

          <template slot="user_gender" slot-scope="user_gender">
            <div class="author-info">
              <!-- <h6 class="m-2"></h6> -->
              <p class="m-0 font-regular text-muted">
                <a-tag :color="user_gender == 1 ? 'blue' : user_gender == 2 ? 'red' : ''
                  ">{{
                    user_gender == 1 ? "男" : user_gender == 2 ? "女" : "未设置"
                  }}</a-tag>
              </p>
            </div>
          </template>
          <template slot="resign" slot-scope='text, row'>
            <a-tag :color="row.resign == 1 ? 'green' : 'red'">{{ row.resign == 1 ? '在职状态' : '离职状态' }}</a-tag>
          </template>
          <template slot="h5openid_remark" slot-scope='text, row'>
            <a-button type="link" @click="addOrUpdatePaymentHandle(row.user_id)"
              :style="{ color: !!row.h5openid ? 'green' : 'red' }">{{ text }}</a-button>
          </template>
          <template slot="openid_remark" slot-scope='text, row'>
            <a-button type="link" @click="addOrUpdatePaymentHandle2(row.user_id)"
              :style="{ color: !!row.openid ? 'green' : 'red' }">{{ text }}</a-button>
          </template>
          <template slot="department.department_name" slot-scope="department_name">
            <a-tag>{{ department_name }}</a-tag>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" style="color: red;" @click="lizhi(row)" v-if="row.resign == 1">
              离职操作
            </a-button>
            <a-button type="link" class="btn-edit" @click="zaizhi(row)" v-if="row.resign == 2">
              设为在职
            </a-button>
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.user_id)">
              编辑
            </a-button>
            <a-button type="link" class="btn-edit" @click="deleteHandle(row.user_id)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    <Lizhi ref="lizhi" @ok="getDataList"></Lizhi>
    <canvas ref="qrcanvas" :width="200" :height="200" hidden></canvas>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
import Lizhi from "./components/lizhi.vue";
import QRCode from 'qrcode';
import { baseURL } from '@/api/index'
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
    Lizhi
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/user/page",
        deleteURL: "/admin/user/delete",
      },
      dataForm: {
        username: "",
        department_id: "",
        resign: "1"
      },
      columns: [
        {
          title: "用户名称",
          dataIndex: "username",
          width: 200
        },
        {
          title: "所属部门",
          dataIndex: "department.department_name",
          scopedSlots: { customRender: "department.department_name" },
          width: 180
        },
        {
          title: "真实姓名",
          dataIndex: "real_name",
          width: 120
        },
        {
          title: "角色",
          dataIndex: "sys_role.role_name",
          width: 120
        },
        {
          title: "微信服务号",
          dataIndex: "h5openid_remark",
          scopedSlots: { customRender: "h5openid_remark" },
          width: 150
        },
        {
          title: "微信小程序",
          dataIndex: "openid_remark",
          scopedSlots: { customRender: "openid_remark" },
          width: 150
        },
        {
          title: "在职状态",
          dataIndex: "resign",
          scopedSlots: { customRender: "resign" },
          width: 120
        },
        {
          title: "手机号",
          dataIndex: "user_phone",
          width: 140
        },
        {
          title: "性别",
          dataIndex: "user_gender",
          scopedSlots: { customRender: "user_gender" },
          width: 80
        },
        {
          title: "邮箱",
          dataIndex: "user_email",
          width: 120
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          class: "text-muted",
          width: 180
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 250,
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    lizhi(row) {
      this.$refs.lizhi.init({
        user_id: row.user_id,
        real_name: row.real_name,
      })
    },
    async addOrUpdatePaymentHandle(user_id) {
      const canvas = this.$refs.qrcanvas;
      //将':7001'替换为:5073
      // https://admin.bzdingshe.com/wxh5/index.html#
      const href = `${baseURL}/wxh5/index.html#/pages/wxh5bind/index?user_id=${user_id}`.replace(/:7001/, ':5173');
      console.log(href)
      // const redirect_uri = encodeURIComponent(href);
      await QRCode.toCanvas(canvas, href);
      const img = canvas.toDataURL('image/png')
      this.$viewerApi({
        images: [img],
      });
    },
    async addOrUpdatePaymentHandle2(user_id) {
      this.$http({
        url: '/admin/user/getJumpMiniProgramShortLink',
        method: "post",
        data: {
          user_id: user_id,
        },
      }).then(async (res) => {
        if(!res.data.url_link){
          this.$message.error('获取失败');
          return;
        }
        const canvas = this.$refs.qrcanvas;
        await QRCode.toCanvas(canvas, res.data.url_link);
        const img = canvas.toDataURL('image/png')
        this.$viewerApi({
          images: [img],
        });
      })
    },
    zaizhi(row) {
      this.$http({
        url: '/admin/user/zaizhi',
        method: "post",
        data: {
          user_id: row.user_id,
        },
      }).then(() => {
        this.$message.success('操作成功');
        this.getDataList()
      })
    }
  },
};
</script>